// actions/alarms.js
import axios from 'axios';
import { apiClient } from '../utils/apiClient';

export const ALARM_ACTIONS = {
  FETCH_ALARMS: 'FETCH_ALARMS',
  CREATE_ALARM: 'CREATE_ALARM',
  TOGGLE_ALARM: 'TOGGLE_ALARM',
  DELETE_ALARM: 'DELETE_ALARM',
  ADD_ALARM_NOTIFICATION: 'ADD_ALARM_NOTIFICATION',
  FETCH_ALARM_NOTIFICATIONS: 'FETCH_ALARM_NOTIFICATIONS',
  MARK_NOTIFICATIONS_READ: 'MARK_NOTIFICATIONS_READ'
};

// Base API URL
const API_BASE_URL = 'https://cloudify-prod.wizr.in/api';

// Fetch all alarms for user
export const fetchAlarms = () => async (dispatch, getState) => {
  try {
    const { userId } = getState().auth.user;
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/alarms`);
    dispatch({
      type: ALARM_ACTIONS.FETCH_ALARMS,
      payload: response.data
    });
  } catch (error) {
    console.error('Error fetching alarms:', error);
  }
};

// Create new alarm
export const createAlarm = (alarmData, projectId, serviceId) => async (dispatch, getState) => {
  try {
    const { userId } = getState().auth.user;
    const data = await apiClient.post(`/api/users/${userId}/alarms`, alarmData, {
      projectId,
      resourceId: serviceId,
      resourceType: 'BACKEND_SERVICE',
      requiredPermission: 'set:alarm'
    });
    if(data){
      dispatch({
        type: ALARM_ACTIONS.CREATE_ALARM,
        payload: data
      });
    }
    return null;
  } catch (error) {
    console.error('Error creating alarm:', error);
    throw error;
  }
};

// Toggle alarm active state
export const toggleAlarm = (alarmId, isActive) => async (dispatch, getState) => {
  try {
    const { userId } = getState().auth.user;
    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}/alarms/${alarmId}/status`,
      { isActive }
    );
    dispatch({
      type: ALARM_ACTIONS.TOGGLE_ALARM,
      payload: { alarmId, isActive }
    });
    return response.data;
  } catch (error) {
    console.error('Error toggling alarm:', error);
    throw error;
  }
};

// Delete alarm
export const deleteAlarm = (alarmId) => async (dispatch, getState) => {
  try {
    const { userId } = getState().auth.user;
    await axios.delete(`${API_BASE_URL}/users/${userId}/alarms/${alarmId}`);
    dispatch({
      type: ALARM_ACTIONS.DELETE_ALARM,
      payload: alarmId
    });
  } catch (error) {
    console.error('Error deleting alarm:', error);
    throw error;
  }
};

// Fetch notifications for a specific alarm
export const fetchAlarmNotifications = (alarmId) => async (dispatch, getState) => {
  try {
    const { userId } = getState().auth.user;
    const response = await axios.get(`${API_BASE_URL}/users/${userId}/alarms/${alarmId}/notifications`);
    dispatch({
      type: ALARM_ACTIONS.FETCH_ALARM_NOTIFICATIONS,
      payload: { alarmId, notifications: response.data }
    });
    
    // Mark notifications as read
    await axios.put(`${API_BASE_URL}/users/${userId}/alarms/${alarmId}/notifications/mark-read`);
    dispatch({
      type: ALARM_ACTIONS.MARK_NOTIFICATIONS_READ,
      payload: alarmId
    });
  } catch (error) {
    console.error('Error fetching alarm notifications:', error);
  }
};